/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import type {
  ArchiveTeamBody,
  AssignTeamMemberBody,
  CreateTeamBody,
  TeamDetail,
  TeamSummary,
  UnassignTeamMemberBody,
  UpdateTeamBody,
} from "../models/index";
import {
  ArchiveTeamBodyFromJSON,
  ArchiveTeamBodyToJSON,
  AssignTeamMemberBodyFromJSON,
  AssignTeamMemberBodyToJSON,
  CreateTeamBodyFromJSON,
  CreateTeamBodyToJSON,
  TeamDetailFromJSON,
  TeamDetailToJSON,
  TeamSummaryFromJSON,
  TeamSummaryToJSON,
  UnassignTeamMemberBodyFromJSON,
  UnassignTeamMemberBodyToJSON,
  UpdateTeamBodyFromJSON,
  UpdateTeamBodyToJSON,
} from "../models/index";

export interface ArchiveTeamRequest {
  archiveTeamBody: ArchiveTeamBody;
}

export interface AssignTeamMemberRequest {
  assignTeamMemberBody: AssignTeamMemberBody;
}

export interface CreateTeamRequest {
  createTeamBody: CreateTeamBody;
}

export interface GetTeamRequest {
  teamId: string;
}

export interface UnassignTeamMemberRequest {
  unassignTeamMemberBody: UnassignTeamMemberBody;
}

export interface UpdateTeamRequest {
  updateTeamBody: UpdateTeamBody;
}

/**
 *
 */
export class PeopleTeamsApi extends runtime.BaseAPI {
  /**
   */
  async archiveTeamRaw(
    requestParameters: ArchiveTeamRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["archiveTeamBody"] == null) {
      throw new runtime.RequiredError(
        "archiveTeamBody",
        'Required parameter "archiveTeamBody" was null or undefined when calling archiveTeam().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/people/teams/archive`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: ArchiveTeamBodyToJSON(requestParameters["archiveTeamBody"]),
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async archiveTeam(
    requestParameters: ArchiveTeamRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.archiveTeamRaw(requestParameters, initOverrides);
  }

  /**
   */
  async assignTeamMemberRaw(
    requestParameters: AssignTeamMemberRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["assignTeamMemberBody"] == null) {
      throw new runtime.RequiredError(
        "assignTeamMemberBody",
        'Required parameter "assignTeamMemberBody" was null or undefined when calling assignTeamMember().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/people/teams/assign`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: AssignTeamMemberBodyToJSON(
          requestParameters["assignTeamMemberBody"],
        ),
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async assignTeamMember(
    requestParameters: AssignTeamMemberRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.assignTeamMemberRaw(requestParameters, initOverrides);
  }

  /**
   */
  async createTeamRaw(
    requestParameters: CreateTeamRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["createTeamBody"] == null) {
      throw new runtime.RequiredError(
        "createTeamBody",
        'Required parameter "createTeamBody" was null or undefined when calling createTeam().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/people/teams/create`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: CreateTeamBodyToJSON(requestParameters["createTeamBody"]),
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async createTeam(
    requestParameters: CreateTeamRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.createTeamRaw(requestParameters, initOverrides);
  }

  /**
   */
  async getTeamRaw(
    requestParameters: GetTeamRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<TeamDetail>> {
    if (requestParameters["teamId"] == null) {
      throw new runtime.RequiredError(
        "teamId",
        'Required parameter "teamId" was null or undefined when calling getTeam().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["teamId"] != null) {
      queryParameters["teamId"] = requestParameters["teamId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/people/teams/get`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      TeamDetailFromJSON(jsonValue),
    );
  }

  /**
   */
  async getTeam(
    requestParameters: GetTeamRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<TeamDetail> {
    const response = await this.getTeamRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async listTeamsRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Array<TeamSummary>>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/people/teams/list`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(TeamSummaryFromJSON),
    );
  }

  /**
   */
  async listTeams(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Array<TeamSummary>> {
    const response = await this.listTeamsRaw(initOverrides);
    return await response.value();
  }

  /**
   */
  async unassignTeamMemberRaw(
    requestParameters: UnassignTeamMemberRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["unassignTeamMemberBody"] == null) {
      throw new runtime.RequiredError(
        "unassignTeamMemberBody",
        'Required parameter "unassignTeamMemberBody" was null or undefined when calling unassignTeamMember().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/people/teams/unassign`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: UnassignTeamMemberBodyToJSON(
          requestParameters["unassignTeamMemberBody"],
        ),
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async unassignTeamMember(
    requestParameters: UnassignTeamMemberRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.unassignTeamMemberRaw(requestParameters, initOverrides);
  }

  /**
   */
  async updateTeamRaw(
    requestParameters: UpdateTeamRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["updateTeamBody"] == null) {
      throw new runtime.RequiredError(
        "updateTeamBody",
        'Required parameter "updateTeamBody" was null or undefined when calling updateTeam().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/people/teams/update`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: UpdateTeamBodyToJSON(requestParameters["updateTeamBody"]),
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async updateTeam(
    requestParameters: UpdateTeamRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.updateTeamRaw(requestParameters, initOverrides);
  }
}
